var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{ref:"resizeBase",staticClass:"resize-base"},[_c('div',{ref:"resizeSensor",staticClass:"resize-sensor",style:({ width: `${this.resizeSensorWidth}px`, height: `${this.resizeSensorHeight}px` })},[_c('div',{ref:"dashboardContainer",staticClass:"dashboard-container",style:({
          width: `${this.dashboardContainerDesignWidth}px`,
          height: `${this.dashboardContainerDesignHeight}px`,
          transform: this.dashboardContainerScale
        })},[_c('a-layout',{staticClass:"layout"},[_c('layout-header'),_c('layout-content')],1)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }